module.exports = __webpack_public_path__ + "static/media/pattern_react.452a8e48.png";